import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { BookingService } from 'src/app/services/booking.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import swal from 'sweetalert2';
import { DriverService } from 'src/app/services/driver.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { GenericValidator } from 'src/app/views/layout/validators/generic-validator';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ManufacturerService } from 'src/app/services/manufacturer.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { result } from 'lodash';
import { ManufacturerpopupComponent } from './manufacturerpopup/manufacturerpopup.component';
import { ManufacturerclarifypopupComponent } from './manufacturerclarifypopup/manufacturerclarifypopup.component';
import { ApproveStatusType } from 'src/enum/approvestatustype';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';
import { ManufacturerUpdatePopupComponent } from './manufacturerupdatepopup/manufacturerupdatepopup.component';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import Swal from 'sweetalert2';
import { SecurityService } from 'src/app/services/security.service';
interface FoodNode {
  name: string;
  color?: string;
  children?: FoodNode[];
  key?: number
}
@Component({
  selector: 'app-manufacturer',
  templateUrl: './manufacturer.component.html',
  styleUrls: ['./manufacturer.component.scss']
})
export class ManufacturerComponent implements OnInit {

  @ViewChild('input1') input1!: ElementRef;
  @ViewChild('input2') input2!: ElementRef;
  @ViewChild('input3') input3!: ElementRef;
  @ViewChild('input4') input4!: ElementRef;

  @Input() actionInfo:any
  balanceSheetFileName: any;
  balanceSheetFileName1: any;
  balanceSheetfiles1: any;
  attachmentbalanceSheetData: any[] = [];
  attachmentbalanceSheetData1: any[] = [];
  balanceSheetfiles2: any;
  attachmentbalanceSheetData2: any[] = [];
  form: FormGroup;
  balancesheetform: FormGroup;
  form1: FormGroup;
  formEditMode: boolean;
  manufacturerListCopy: any[];
  manufacturerList: any[];
  subDistrictList: any[] = [];
  subDistrictListCopy: any[] = [];
  villageList: any[];
  villageListCopy: any[] = [];
  stateList: any[];
  stateListCopy: any[];
  districtList: any[];
  districtListCopy: any[];
  showtextdistrict = false;
  manufacturer: boolean = false;
  manufactureranddealer: boolean = false;
  organisationTypeList: any[];
  organisationTypeListCopy: any[];
  dropdownSettings: any = {};
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  register: boolean;
  formp3: FormGroup;
  manufacturerDetail: any;
  registrationType: any;
  manufacturerType: any = [];
  loading: boolean = true;
  disabled: boolean = false;
  organisationTNamedisabled: boolean = false;
  disabledaddress: boolean = false;
  companyListCopy: any;
  companyList: any;
  today: Date;
  max: Date;
  minDate: Date;
  manufactuerss: any;
  type: any;
  msme: any;
  routeParams: any;
  id: any;
  actioninfo: any;
  isdisable: boolean = false;
  isCorporateContact: boolean = true;
  isAuthorizedContact: boolean = true;
  isBalanceSheet: boolean = true;
  ismsme: boolean = true;
  balanceRequired: boolean = false;
  loginid: any;
  loadBalanceList: any[] = [];
  gstImagePath: string;
  panImagePath: string;
  msmeImagePath: string;
  show: boolean = false;
  gstStatus: boolean = false;
  verify: boolean = false;
  gstDetail: any;
  statusType: number;
  val: any;
  panno: any;
  disabledstateaddress: boolean;
  disableddistrictaddress: boolean;
  isGstVerified: boolean;
  isContinue: boolean;
  manufacturerId: any;
  view: boolean = false;
  loadbalance: boolean = false;
  manufactureredit: any[] = [];
  roleId: any;
  incorporationImagePath: any;
  tINImagePath: any;
  miscellaneousImagePath: any;
  cnImagePath: string;
  upload: boolean = false;
  balanceSheetFileName2: any;
  fileType: number;
  balanceSheetfiles: any;
  filesResult: any;
  balanceSheetData: any[] = [];
  msmeFileName: any;
  msmefiles: any;
  attachmentData: any[] = [];
  manufacturerTypeList: any[] = [];
  maindisabled: boolean = false;
  isSeekClarification: boolean = false;
  manufacturerTypeIdList: any[] = [];
  loginId: any;
  selectedTabIndex: number;
  treeControl = new NestedTreeControl<FoodNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  productTreeList: any[] = [];
  TREE_DATA: FoodNode[] = [];
  organisationName: any;
  organisationTName: any;
  showOtpBtnMobile: boolean;
  mobileNoInputDisabel: boolean;
  showEmailEdit :boolean;
  showMobileEdit : boolean
  showOTPinput: boolean;
  pinValue: string;
  showOTPsendBtn: boolean;
  emailEditDisabel :boolean;
  otp: any;
resendSec: any;
time: any;
  mobileNumberSec: boolean;
  play: boolean;
  interval: NodeJS.Timeout;
  companyResendSec: boolean;
  emailInputDisabel: boolean;
  showOtpBtnEmail: boolean;
  showOTPinputEmail: boolean;
  showEmailOTPsendBtn: boolean;
  manufacturersshow : boolean;
  prop: boolean;
  constructor(private formBuilder: FormBuilder,
    private alertService: AlertService,
    private driverService: DriverService,
    public showDialog: MatDialog,
    private bookingService: BookingService,
    private usersession: UserSessionService,
    private manufacturerService: ManufacturerService,
    private navigationService: NavigationService,
    private cashBookingService: CashBookingService,
    private genericValidator: GenericValidator,
    private securityService: SecurityService,
    private _location: Location,
    public addServiceDialog: MatDialog,
    route: ActivatedRoute,
    private router: Router) {
    this.stateList = [];
    this.stateListCopy = [];
    this.districtList = [];
    this.districtListCopy = [];
    this.organisationTypeList = [];
    this.organisationTypeListCopy = [];
    this.formEditMode = true;
    this.roleId = this.usersession.roleId();
    this.routeParams = route.snapshot.params;
    const decId = this.securityService.decrypt(this.routeParams.id);
    this.id = decId;
    this.actioninfo = this.routeParams.actionInfo;
    if (this.roleId == RoleType.DBTAdmin) {
      this.maindisabled = true;
    } else {
      this.maindisabled = false;
    }
    if (this.roleId == RoleType.Manufacturer){
      this.manufacturersshow = true;
    } else {
      this.manufacturersshow = false;
    }
    if (this.actioninfo == 1) {
      this.isdisable = true;
    }
    if (this.actioninfo == 2) {
      this.view = true;
      this.maindisabled = true;
    }
    if (this.actioninfo == 3) {
      this.show = true;
    }
  }

  ngOnInit(): void {
    this.initializeValidators();
    this.getStates();
    this.getmanufacturerList(true);
    // this.getmanufacturerTree(true);
    this.getcompanyRegisteredList(true);
    this.today = new Date();
    this.max = new Date(moment(new Date()).add(1, 'days').format('YYYY, MM, DD'));
    this.loading = false;
    this.disabled = true;
    this.disabledaddress = true;
    this.mobileNoInputDisabel = true;
    this.emailInputDisabel = true;
    this.showMobileEdit = true;
    this.showEmailEdit = true;
    // this.manufacturer = true;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
  }

  mobileDataCancel(){
    Swal.fire({
      title: "Are you sure wanted to quit?",
      icon: "warning", 
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then((result) => {
      if (result.isConfirmed) {
        this.showOtpBtnMobile = false;
        this.mobileNoInputDisabel = true;
        this.showEmailEdit = true;
        this.form.get('mobileNo').setValue(this.manufacturerDetail.mobileNo);
        // window.location.reload();
        
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
    
  }
  emailDataCancel(){
    Swal.fire({
      title: "Are you sure wanted to quit?",
      icon: "warning", 
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then((result) => {
      if (result.isConfirmed) {
        this.showOtpBtnEmail = false;
        this.emailInputDisabel = true;
        this.showMobileEdit = true;
        this.form.get('email').setValue(this.manufacturerDetail.email);
       
        
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
    
  }
  SendOTPEmail() {
    if (this.form.value.email && this.form.controls['email'].valid) 
      {
        var data = {
          "id":this.manufacturerDetail.id,   
          "mobileNo": this.form.value.mobileNo,
          "langType": 1,
        }
    
      this.manufacturerService.sendOtp(data).subscribe(res => {
        if (!res.isSuccess) {
            this.showOTPinputEmail = false;
            this.showOtpBtnEmail = true;
            this.form.controls['email'].setValue(null);

            this.alertService.error('Email already linked with another account');
        }
        else {
          this.alertService.success(this.resendSec ?'OTP Resent successfully':'OTP sent successfully');
          this.showOTPinputEmail = true;
          this.showOtpBtnEmail = false;
          this.generate2OTP();
        }
      });
    }
    else {
      this.alertService.error('Plese Enter Email')
    }


  }
SendOTPMobile() {
    if (this.form.value.mobileNo && this.form.controls['mobileNo'].valid) 
      {
        var data = {
          "id":this.manufacturerDetail.id,
          "email": this.form.value.email,
          "langType": 1,
        }
      this.manufacturerService.sendOtp(data).subscribe(res => {
        if (!res.isSuccess) {
            this.showOTPinput = false;
            this.showOtpBtnMobile = true;
            this.form.controls['mobileNo'].setValue(null);

            this.alertService.error('Mobile number already linked with another account');
        }
        else {
          this.alertService.success(this.resendSec ?'OTP Resent successfully':'OTP sent successfully');
          this.showOTPinput = true;
          this.showOtpBtnMobile = false;
          this.generate2OTP();
        }
      });
    }
    else {
      this.alertService.error('Plese Enter Mobile Number')
    }


  }
  generate2OTP() {
    this.form.controls['otp1'].setValue('');
    this.form.controls['otp2'].setValue('');
    this.form.controls['otp3'].setValue('');
    this.form.controls['otp4'].setValue('');
    if (this.form.value.mobileNo) {
      const otps ={
        
      }
      
      this.startTimer();
      // this.OnCaptachaValidators();
      // this.form.controls['otp1'].setValue(null);
      this.mobileNumberSec = false;
    } else {
      this.alertService.error('Please fill the Mandatory fields');
      this.genericValidator.validateFormControl(this.form);
    }
  }
  startTimer() {
    this.play = true;
    this.time = 60;
    this.interval = setInterval(() => {
      if (this.time > 0) {
        this.time--;
        this.resendSec = false;
        this.companyResendSec = false;
      } else if (this.time == 0) {
        this.resendSec = true;
        this.companyResendSec = true;
        clearInterval(this.interval);
      } 
    }, 1000);
  }


moveFocus(event: KeyboardEvent, name: string) {
  let inputElement = event.target as HTMLInputElement;
  inputElement.value = inputElement.value.replace(/[^0-9]/g, ''); // Allow only numbers9381936356

  if (event.key === 'Backspace' && inputElement.value === '') {
    if (name === 'otp4') this.input3.nativeElement.focus();
    else if (name === 'otp3') this.input2.nativeElement.focus();
    else if (name === 'otp2') this.input1.nativeElement.focus();
  } else if (inputElement.value.length === 1) {
    if (name === 'otp1') this.input2.nativeElement.focus();
    else if (name === 'otp2') this.input3.nativeElement.focus();
    else if (name === 'otp3') this.input4.nativeElement.focus();
  }

  this.pinValue = `${this.form.value.otp1}${this.form.value.otp2}${this.form.value.otp3}${this.form.value.otp4}`;

  if (this.pinValue.length === 4) {
    // this.submitdisable = false;
    // this.navNext();
  }
}


cancelMobileNoSubmit(){
    this.mobileNoInputDisabel = true;
    this.showOTPsendBtn = false;
    this.showOTPinput = false
    this.mobileNoInputDisabel = true;
    this.mobileDataCancel();
    this.form.get('mobileNo').setValue(this.manufacturerDetail.mobileNo);
  }
cancelEmailSubmit(){
    this.emailInputDisabel = true;
    this.showEmailOTPsendBtn = false;
    this.showOTPinputEmail = false;
    this.emailDataCancel();
    // this.mobileNoInputDisabel = true;
    this.form.get('email').setValue(this.manufacturerDetail.email);
  }
  VerifyWithOTPEmail() {   
   if (this.form.value.email && this.form.controls['email'].valid) {
    const otp =
      (this.form.value.otp1 || '') +
      (this.form.value.otp2 || '') +
      (this.form.value.otp3 || '') +
      (this.form.value.otp4 || '');
    if (otp.length !== 4) {
      console.error("Invalid OTP: Ensure all 4 digits are entered.");
      this.alertService.error('Invalid OTP: Ensure all 4 digits are entered');
      return;
    }

    const data = {
      id: this.manufacturerDetail?.id,
      enteredOtp: otp
    };

    this.manufacturerService.OtpVerification(data,true).subscribe(result => {
      if (result.isSuccess) {
        this.alertService.success('OTP verified successfully ');
        this.emailInputDisabel = true;
          this.showEmailOTPsendBtn = true;
             this.showOTPinputEmail = false;
        
      } else {
        console.error("OTP Verification Failed");
        this.alertService.error('Please enter a valid OTP');
      }
    }, error => {
      console.error("Error verifying OTP:", error);
    });
  } else {
    console.error("Invalid email or form submission.");
  }
  this.emailInputDisabel = true;
  }

  VerifyWithOTPMobile() {  
        if (this.form.value.mobileNo && this.form.controls['mobileNo'].valid) {
      const otp =
        (this.form.value.otp1 || '') +
        (this.form.value.otp2 || '') +
        (this.form.value.otp3 || '') +
        (this.form.value.otp4 || '');
      if (otp.length !== 4) {
        console.error("Invalid OTP: Ensure all 4 digits are entered.");
        this.alertService.error('Invalid OTP: Ensure all 4 digits are entered');
        return;
      }
  
      const data = {
        id: this.manufacturerDetail?.id,
        enteredOtp: otp
      };
  
      this.manufacturerService.OtpVerification(data,true).subscribe(result => {
        if (result.isSuccess) {
          this.alertService.success('OTP verified successfully ');
          this.mobileNoInputDisabel = true;
                  this.showOTPsendBtn = true;
                     this.showOTPinput = false;;
          
        } else {
          console.error("OTP Verification Failed");
          this.alertService.error('Please enter a valid mobile number');
        }
      }, error => {
        console.error("Error verifying OTP:",);
      });
    } else {
      console.error("Invalid email or form submission.");
    }
    this.mobileNoInputDisabel = true;
  }

cancelMobileNoUpdate(){
    this.mobileNoInputDisabel = true;
    this.showOTPsendBtn = false;
    this.form.get('mobileNo').setValue(this.manufacturerDetail.mobileNo);
  }

  cancelEmailUpdate(){
    this.emailInputDisabel = true;
    this.showEmailOTPsendBtn = false;
    this.form.get('email').setValue(this.manufacturerDetail.email);
  }
  UpadteConfrim() {
    if(this.form.valid){
      Swal.fire({
        title: "Are you sure?",
        text: "You wanted to update ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then((result) => {
        if (result.isConfirmed) {
          let data = {
            id: this.manufacturerDetail.id,
            mobileNo: this.form.value.mobileNo,
            email: this.form.value.email,
            customerCareNo: this.form.value.customerCareNo,
            customerCareNo1: this.form.value.customerCareNo1,
            customerCareNo2: this.form.value.customerCareNo2,
            organisationTName: this.form.value.organisationTName,
            corporateContactPersonName: this.form.value.corporateContactPersonName,
            corporateContactPersonEmail: this.form.value.corporateContactPersonEmail,
            corporateContactPersonDesignation: this.form.value.corporateContactPersonDesignation,
            corporateContactPersonMobileNo: this.form.value.corporateContactPersonMobileNo,
            authorizedPersonName: this.form.value.authorizedPersonName,
            authorizedPersonEmail: this.form.value.authorizedPersonEmail,
            authorizedPersonDesignation: this.form.value.authorizedPersonDesignation,
            authorizedPersonMobileNo: this.form.value.authorizedPersonMobileNo,
            certificateNumber: this.form.value.certificateNumber,
            manufacturerType: JSON.stringify(this.manufacturerTypeIdList),
            validityEndTs: this.form.value.validityEndTs ? moment(this.form.value.validityEndTs).format('YYYY-MM-DD') : null,
            validityStartTs: this.form.value.validityStartTs ? moment(this.form.value.validityStartTs).format('YYYY-MM-DD') : null,
            attachment: this.attachmentData,
            dbtManufacturerBalanceSheetMappingViewModel: this.balanceSheetData,
          };
  
    this.manufacturerService.update(data).subscribe((response) => {
      if (response) {
        Swal.fire({
          title: "Update",
          text: "Your changes have been updated.",
          icon: "success"
        });
      }
    });
        }
        else{
          this.form.get('mobileNo').setValue(this.manufacturerDetail.mobileNo);
          this.form.get('email').setValue(this.manufacturerDetail.email);
        }
      });
    } 

    else{
      this.form.markAllAsTouched();
    }
  }
  
  // UpadteConfrim(){
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You wanted to update ",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No"
  //   }).then((result) => {
  //     if (result.isConfirmed) {}
  //     let data = {
  //       id: this.manufacturerDetail.id,
  //       mobileNo: this.form.value.mobileNo,
  //       email: this.form.value.email,
  //       customerCareNo: this.form.value.customerCareNo,
  //       customerCareNo1: this.form.value.customerCareNo1,
  //       customerCareNo2: this.form.value.customerCareNo2,
  //       organisationTName: this.form.value.organisationTName,
  //       corporateContactPersonName: this.form.value.corporateContactPersonName,
  //       corporateContactPersonEmail: this.form.value.corporateContactPersonEmail,
  //       corporateContactPersonDesignation: this.form.value.corporateContactPersonDesignation,
  //       corporateContactPersonMobileNo: this.form.value.corporateContactPersonMobileNo,
  //       authorizedPersonName: this.form.value.authorizedPersonName,
  //       authorizedPersonEmail: this.form.value.authorizedPersonEmail,
  //       authorizedPersonDesignation: this.form.value.authorizedPersonDesignation,
  //       authorizedPersonMobileNo: this.form.value.authorizedPersonMobileNo,
  //       certificateNumber: this.form.value.certificateNumber,
  //       manufacturerType: JSON.stringify(this.manufacturerTypeIdList),
  //       validityEndTs: (this.form.value.validityEndTs == "" || this.form.value.validityEndTs == null) ? null : moment(this.form.value.validityEndTs).format('YYYY-MM-DD'),
  //       validityStartTs: (this.form.value.validityStartTs == "" || this.form.value.validityStartTs == null) ? null : moment(this.form.value.validityStartTs).format('YYYY-MM-DD'),
  //       attachment: this.attachmentData,
  //       dbtManufacturerBalanceSheetMappingViewModel: this.balanceSheetData,
  //     }

  //     this.manufacturerService.update(data).subscribe((result) => {
  //       if(result) {
  //         // this.alertService.success("data updated successfully")
  //       }
  //     })
  //     if (result.isConfirmed) {
  //       Swal.fire({
  //         // this.
  //         title: "Update",
  //         text: "Your Changes has been Update.",
  //         icon: "success"
          
  //       });
  //     }
     
      
  //   });
  // }
mobileNumberConfrim(){
  if(this.form.valid){
      Swal.fire({
        title: "Are you sure?",
        text: "You wanted to update the mobile number",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then((result) => {

        let data = {
          id: this.manufacturerDetail.id,
          mobileNo: this.form.value.mobileNo,
          email: this.form.value.email,
          customerCareNo: this.form.value.customerCareNo,
          customerCareNo1: this.form.value.customerCareNo1,
          customerCareNo2: this.form.value.customerCareNo2,
          organisationTName: this.form.value.organisationTName,
          corporateContactPersonName: this.form.value.corporateContactPersonName,
          corporateContactPersonEmail: this.form.value.corporateContactPersonEmail,
          corporateContactPersonDesignation: this.form.value.corporateContactPersonDesignation,
          corporateContactPersonMobileNo: this.form.value.corporateContactPersonMobileNo,
          authorizedPersonName: this.form.value.authorizedPersonName,
          authorizedPersonEmail: this.form.value.authorizedPersonEmail,
          authorizedPersonDesignation: this.form.value.authorizedPersonDesignation,
          authorizedPersonMobileNo: this.form.value.authorizedPersonMobileNo,
          certificateNumber: this.form.value.certificateNumber,
          manufacturerType: JSON.stringify(this.manufacturerTypeIdList),
          validityEndTs: (this.form.value.validityEndTs == "" || this.form.value.validityEndTs == null) ? null : moment(this.form.value.validityEndTs).format('YYYY-MM-DD'),
          validityStartTs: (this.form.value.validityStartTs == "" || this.form.value.validityStartTs == null) ? null : moment(this.form.value.validityStartTs).format('YYYY-MM-DD'),
          attachment: this.attachmentData,
          dbtManufacturerBalanceSheetMappingViewModel: this.balanceSheetData,
        }

        this.manufacturerService.update(data).subscribe((result) => {
          if(result) {
            // this.alertService.success("data updated successfully")
          }
        })
        if (result.isConfirmed) {
          Swal.fire({
            // this.
            title: "Update",
            text: "Your Changes has been Update.",
            icon: "success"
            
          });
        }
        else{
          this.form.get('mobileNo').setValue(this.manufacturerDetail.mobileNo);
          this.form.get('email').setValue(this.manufacturerDetail.email);
        }
        this.showOtpBtnMobile = false;
        this.showOTPinput = false;
        // this.showEmailEdit = false;
        this.mobileNoInputDisabel = true;
        this.emailEditDisabel= true;
        this.showOTPsendBtn= false;
      });
    }
    else{
      this.form.markAllAsTouched();
    }
  }
 
  emailConfrim(){
    Swal.fire({
      title: "Are you sure?",
      text: "You wanted to update the email",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then((result) => {

      let data = {
        id: this.manufacturerDetail.id,
        mobileNo: this.form.value.mobileNo,
        email: this.form.value.email,
        customerCareNo: this.form.value.customerCareNo,
        customerCareNo1: this.form.value.customerCareNo1,
        customerCareNo2: this.form.value.customerCareNo2,
        organisationTName: this.form.value.organisationTName,
        corporateContactPersonName: this.form.value.corporateContactPersonName,
        corporateContactPersonEmail: this.form.value.corporateContactPersonEmail,
        corporateContactPersonDesignation: this.form.value.corporateContactPersonDesignation,
        corporateContactPersonMobileNo: this.form.value.corporateContactPersonMobileNo,
        authorizedPersonName: this.form.value.authorizedPersonName,
        authorizedPersonEmail: this.form.value.authorizedPersonEmail,
        authorizedPersonDesignation: this.form.value.authorizedPersonDesignation,
        authorizedPersonMobileNo: this.form.value.authorizedPersonMobileNo,
        certificateNumber: this.form.value.certificateNumber,
        manufacturerType: JSON.stringify(this.manufacturerTypeIdList),
        validityEndTs: (this.form.value.validityEndTs == "" || this.form.value.validityEndTs == null) ? null : moment(this.form.value.validityEndTs).format('YYYY-MM-DD'),
        validityStartTs: (this.form.value.validityStartTs == "" || this.form.value.validityStartTs == null) ? null : moment(this.form.value.validityStartTs).format('YYYY-MM-DD'),
        attachment: this.attachmentData,
        dbtManufacturerBalanceSheetMappingViewModel: this.balanceSheetData,
      }

      this.manufacturerService.update(data).subscribe((result) => {
        if(result) {
          // this.alertService.success("data updated successfully")
        }
      })
      if (result.isConfirmed) {
        Swal.fire({
          // this.
          title: "Update",
          text: "Your Changes has been Update.",
          icon: "success"
          
        });
      }
      this.showOtpBtnEmail = false;
      this.showOTPinputEmail = false;
      this.emailInputDisabel = true;
      // this.showMobileEdit = false;
      this.emailEditDisabel= true;
      this.showEmailOTPsendBtn= false;
    });
}

  ChangeMobileNumber() {
    this.showEmailEdit = false ;
    this.mobileNoInputDisabel = false;
    this.showOtpBtnMobile = true;
    this.form.get('mobileNo').reset();
    
  }
  ChangeEmail() {
    this.showMobileEdit = false;
    this.emailInputDisabel = false;
    this.showOtpBtnEmail = true;
    this.form.get('email').reset();
    
  }
  balancesheetSave() {
    if (this.balancesheetform.valid) {
      // this.wizardForm.goToNextStep();
    } else {
      this.alertService.error('Please fill the Mandatory fields');
      this.genericValidator.validateFormControl(this.balancesheetform);
    }
  }
  changeOptions(event: any) {
    if (event.value == 1) {
      this.manufacturer = true;
      this.registrationType = event.value;
      this.register = this.manufacturer;
      this.manufactureranddealer = false;
    } else {
      this.manufacturer = false;
      this.manufactureranddealer = true;
      this.registrationType = event.value;
      this.register = this.manufactureranddealer;
    }
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      mobileNo: ['', Validators.required],
      organisationName: [''],
      organisationTName: [''],
      constitutionOfBusiness: ['', Validators.required],
      panNo: [''],
      gstNo: [''],
      tinNo: [''],
      faxNo: [''],
      gstStatus: [''],
      website: [''],
      // manufacturerType: [''],
      organisationAddress: [''],
      pinCode: [''],
      stateId: [''],
      talukId: [''],
      villageId: [''],
      incorporationTs: [''],
      districtId: [''],
      customerCareNo: [''],
      customerCareNo1: [''],
      customerCareNo2: [''],
      corporateContactPersonName: ['', Validators.required],
      corporateContactPersonDesignation: ['', Validators.required],
      corporateContactPersonMobileNo: ['', Validators.required],
      corporateContactPersonEmail: ['', Validators.required],
      authorizedPersonName: ['', Validators.required],
      authorizedPersonDesignation: ['', Validators.required],
      authorizedPersonMobileNo: ['', Validators.required],
      authorizedPersonEmail: ['', Validators.required],
      email: ['', { validators: [Validators.required, Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')] }],
      companyRegisterType: ['', Validators.required],
      certificateNumber: [''],
      validityEndTs: [''],
      validityStartTs: [''],
      otp1:[''],
      otp2:[''],
      otp3:[''],
      otp4:[''],
      // manufacturerType: [null],
      msme_file: [''],
      msme_filename: ['', ''],
      // balanceSheet_file: [''],
      // balanceSheet_filename: ['', ''],
    });
    this.balancesheetform = this.formBuilder.group({
      year: [''],
      turnover: [''],
      turnover1: [''],
      turnover2: [''],
      balanceSheet_file: [''],
      balanceSheet_filename: ['', ''],
      balanceSheet_file1: [''],
      balanceSheet_filename1: ['', ''],
      balanceSheet_file2: [''],
      balanceSheet_filename2: ['', ''],


    });

    this.form1 = this.formBuilder.group({
      registrationType: [''],
      manufacturerType: [''],
    });
  }


  getmanufacturerTree(refresh: boolean) {
    this.productTreeList = [];
    this.manufacturerService
      .getManufacturerTreeChart(this.id, refresh)
      .subscribe((result) => {
        if (result) {
          this.TREE_DATA.push(result);
          this.dataSource.data = this.TREE_DATA;
        }
      });
  }

  getColor(node: FoodNode) {
    if (this.dataSource.data[0]?.children?.[0]?.children?.length === 0) {
      return 'white'
    } else if (!this.dataSource.data[0]?.children?.[0]?.children?.[0].children) {
      if (!node?.children) {
        return node.color
      } else {
        return 'white'
      }
    } else if (!node?.children?.[0]?.children || !node?.children) {
      return node.color;
    } else {
      return 'white'
    }
  }

  getBgColor(node: FoodNode) {
    if (this.dataSource.data[0]?.children?.[0]?.children?.length === 0) {
      return node.color
    } else if (!this.dataSource.data[0]?.children?.[0]?.children?.[0].children) {
      if (!node?.children) {
        return 'white'
      } else {
        return node.color
      }
    } else if (!node?.children?.[0]?.children || !node?.children) {
      return 'white'
    } else {
      return node.color;
    }
  }

  expand() {
    this.dataSource.data.forEach(node => {
      if (node.children && node.children) {
        this.treeControl.expand(node);
        node.children.forEach(node1 => {
          this.treeControl.expand(node1);
          node1.children.forEach(node2 => {
            this.treeControl.expand(node2);
          });
        });
      }
    });
  }
  collapse() {
    this.treeControl.collapseAll();
  }
  hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;

  isGstVerify() {
    if (this.form.controls['gstNo'].valid) {
      this.loading = true;
      this.bookingService.getGstCheck(this.form.value.gstNo, true).subscribe(res => {
        if (res) {
          this.gstDetail = res;
          this.statusType = 1;
          this.val = this.form.value.gstNo;
          this.panno = this.val.slice(2, -3);
          this.disabled = true;
          this.disabledaddress = true;
          this.disabledstateaddress = true;
          this.disableddistrictaddress = true;
          this.isGstVerified = true;
          let state = this.stateListCopy.filter(i => i.value.trim().toLowerCase() == res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.stateName.trim().toLowerCase());
          if (state != null && state.length > 0) {
            this.form.controls['stateId'].setValue(state[0].key);
            this.cashBookingService.districtByState(state[0].key, true).subscribe(result => {
              if (result) {
                this.districtList = result;
                this.districtListCopy = result;
                let district = result.filter(i => i.value.trim().toLowerCase() == res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.districtName.trim().toLowerCase());
                if (district != null && district.length > 0) {
                  this.form.controls['districtId'].setValue(district[0].key);
                  if (this.districtListCopy[0].key) {
                    this.cashBookingService.talukData(district[0].key, 1, true).subscribe(result => {
                      if (result) {
                        this.subDistrictList = result;
                        this.subDistrictListCopy = result;
                      }
                    });
                  }
                } else {
                  this.disabledaddress = false;
                  this.disableddistrictaddress = false;
                }
              }
            });

          } else {
            this.disabledaddress = false;
            this.disabledstateaddress = false;
            this.disableddistrictaddress = false;
          }
          let address = (res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.buildingNumber).concat(res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.location, ",", res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.streetName, ",", res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.districtName, ",", res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.stateName, ",", res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.pincode);
          this.form.controls['organisationName'].setValue(res.constitutionOfBusiness);
          this.form.controls['organisationTName'].setValue(res.organisationTName);
          this.form.controls['constitutionOfBusiness'].setValue(res.legalNameOfBusiness);
          this.form.controls['pinCode'].setValue(res.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress.pincode);
          this.form.controls['organisationAddress'].setValue(address);
          this.form.controls['gstStatus'].setValue(res.gstnStatus);
          this.form.controls['panNo'].setValue(this.panno);
          this.loading = false;
        } else {

          this.alertService.error('Invalid GST No');
          this.loading = false;

        }
      });
    }

  }

  getmanufacturerList(refresh: boolean) {

    this.manufacturerList = [];
    this.manufacturerListCopy = [];
    this.manufacturerService.getManufacturerList(refresh).subscribe(result => {
      if (result) {
        this.manufacturerList = result;
        this.manufacturerListCopy = this.manufacturerList;
        this.manufacturerListCopy = this.manufacturerListCopy.slice();
    this.getManufacturerDetail();

      }
    });
  }

  ischangeEvent() {

    var date = moment(this.form.value.startDate).format('YYYY-MM-DD');
    this.minDate = new Date(date);
  }

  onmsmeFileSelected(event1: any) {
    const file = event1.target.files[0];
    if ((file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.msmeFileName = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/")
        if (getFileType[1] == 'pdf') {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.msmefiles = event.target.result;
            this.filesResult = event.target.result.split(',')[1];
            this.form.controls['msme_file'].setValue(this.filesResult);
            this.form.controls['msme_filename'].setValue(file.name);
            this.attachmentData.push({
              'id': ((this.attachmentData.length) + 1) - 1,
              'base64String': this.filesResult,
              'attachmentFilename': file.name,
              'fileType': this.fileType,
              'attachmentType': 16
            });
          }

        }
      } else {
        this.alertService.warning('File size is large, Please upload less than 2 MB');
      }
    } else {
      this.alertService.warning('Please upload JPG, JPEG, PNG and PDF only');
    }

  }


  onCancel() {
    this.manufacturerTypeList = [];
    this.manufacturer = false;
    this.manufactureranddealer = false;
    this.getManufacturerDetail();
  }
  onBalanceSheetFileSelected(i, event1: any) {
    if (i == 0) {
      const file = event1.target.files[0];
      if ((file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        let filesize = file.size;
        let acceptsize = parseInt((filesize / 1024).toFixed(2));
        if (acceptsize <= 2048) {
          this.balanceSheetFileName = file.name;
          let checkType = file.type;
          let getFileType = checkType.split("/")
          if (getFileType[1] == 'pdf') {
            this.fileType = 2;
          } else {
            this.fileType = 1;
          }
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.balanceSheetfiles = event.target.result;
              this.filesResult = event.target.result.split(',')[1];
              this.balancesheetform.controls['balanceSheet_file'].setValue(this.filesResult);
              this.balancesheetform.controls['balanceSheet_filename'].setValue(file.name);
              this.attachmentbalanceSheetData.push({
                'id': ((this.attachmentbalanceSheetData.length) + 1) - 1,
                'base64String': this.filesResult,
                'attachmentFilename': file.name,
                'fileType': this.fileType,
                'attachmentType': 17
              });
            }
          }
        } else {
          this.alertService.warning('File size is large, Please upload less than 2 MB');
        }
      } else {
        this.alertService.warning('Please upload JPG, JPEG, PNG and PDF only');
      }
    }
    else if (i == 1) {
      const file = event1.target.files[0];
      if ((file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        let filesize = file.size;
        let acceptsize = parseInt((filesize / 1024).toFixed(2));
        if (acceptsize <= 2048) {
          this.balanceSheetFileName1 = file.name;
          let checkType = file.type;
          let getFileType = checkType.split("/")
          if (getFileType[1] == 'pdf') {
            this.fileType = 2;
          } else {
            this.fileType = 1;
          }
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.balanceSheetfiles1 = event.target.result;
              this.filesResult = event.target.result.split(',')[1];
              this.balancesheetform.controls['balanceSheet_file1'].setValue(this.filesResult);
              this.balancesheetform.controls['balanceSheet_filename1'].setValue(file.name);
              this.attachmentbalanceSheetData1.push({
                'id': ((this.attachmentbalanceSheetData1.length) + 1) - 1,
                'base64String': this.filesResult,
                'attachmentFilename': file.name,
                'fileType': this.fileType,
                'attachmentType': 17
              });
            }
          }
        } else {
          this.alertService.warning('File size is large, Please upload less than 2 MB');
        }
      } else {
        this.alertService.warning('Please upload JPG, JPEG, PNG and PDF only');
      }
    }
    else {
      const file = event1.target.files[0];
      if ((file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        let filesize = file.size;
        let acceptsize = parseInt((filesize / 1024).toFixed(2));
        if (acceptsize <= 2048) {
          this.balanceSheetFileName2 = file.name;
          let checkType = file.type;
          let getFileType = checkType.split("/")
          if (getFileType[1] == 'pdf') {
            this.fileType = 2;
          } else {
            this.fileType = 1;
          }
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.balanceSheetfiles2 = event.target.result;
              this.filesResult = event.target.result.split(',')[1];
              this.balancesheetform.controls['balanceSheet_file2'].setValue(this.filesResult);
              this.balancesheetform.controls['balanceSheet_filename2'].setValue(file.name);
              this.attachmentbalanceSheetData2.push({
                'id': ((this.attachmentbalanceSheetData2.length) + 1) - 1,
                'base64String': this.filesResult,
                'attachmentFilename': file.name,
                'fileType': this.fileType,
                'attachmentType': 17
              });
            }
          }
        } else {
          this.alertService.warning('File size is large, Please upload less than 2 MB');
        }
      } else {
        this.alertService.warning('Please upload JPG, JPEG, PNG and PDF only');
      }
    }

  }


  // onChange(){
  //   this.msme = this.form.value.companyRegisterType;
  //   if(this.msme == 1)
  //   {
  //     this.form.controls['certificateNo'].setValidators(Validators.required);
  //     this.form.controls['certificateNo'].updateValueAndValidity();
  //     this.form.controls['startDate'].setValidators(Validators.required);
  //     this.form.controls['startDate'].updateValueAndValidity();
  //     this.form.controls['endDate'].setValidators(Validators.required);
  //     this.form.controls['endDate'].updateValueAndValidity();
  //   }
  //   else{
  //     this.form.controls['certificateNo'].clearValidators();
  //     this.form.controls['certificateNo'].updateValueAndValidity();
  //     this.form.controls['startDate'].clearValidators();
  //     this.form.controls['startDate'].updateValueAndValidity();
  //     this.form.controls['endDate'].clearValidators();
  //     this.form.controls['endDate'].updateValueAndValidity();
  //   }
  // }


  getStates() {
    this.stateList = [];
    this.driverService.getStateLookUp(true).subscribe(res => {
      if (res) {
        this.stateList = res;
        this.stateListCopy = res;
      }
    });
  }

  getManufacturerDetail() {
    this.loading = true;
    this.manufacturerService.getManufacturer(this.id, true).subscribe(res => {
      if (res) {
        let manufacturerType = JSON.parse(res?.manufacturerType);
        manufacturerType?.forEach(element => {
          let item = this.manufacturerListCopy?.filter(i => i.key == element);
          this.manufacturerTypeList.push(item[0]);
        });
        this.form1.controls["manufacturerType"].setValue(this.manufacturerTypeList);
        this.form1.controls['manufacturerType'].clearValidators();
        this.loadBalanceList = []
        this.manufacturerDetail = res;
        this.loginId = res.loginId;
        this.organisationName = res?.organisationName;
        this.organisationTName = res?.organisationTName;
        if (this.organisationTName) {
          this.organisationTNamedisabled = true;
        }
        if(/Pro|pro|PRO/.test(res.constitutionOfBusiness))
          {
            this.prop=true;
          }
        this.isSeekClarification = res.isSeekClarification;
        if (res.manufacturerEditType != "") {
          this.manufactureredit = JSON.parse(res.manufacturerEditType);
          if (this.manufactureredit && this.manufactureredit.length > 0 && res.approvedStatusType == ApproveStatusType.YettobeVerified && this.roleId != RoleType.DBTAdmin) {
            this.manufactureredit.forEach(element => {
              if (element == 1) {
                this.isCorporateContact = false;
              }
              if (element == 2) {
                this.isAuthorizedContact = false;
              }
              if (element == 3) {
                this.isBalanceSheet = false;
              }
              if (element == 4) {
                this.ismsme = false;
              }
            });
          }
        }
        this.form.controls['incorporationTs'].disable();
        // this.form.controls['validityEndTs'].disable();
        // this.form.controls['validityStartTs'].disable();
        this.gstImagePath = res.gstImagePath;
        this.panImagePath = res.panImagePath;


        this.incorporationImagePath = res.incorporationImagePath;
        this.tINImagePath = res.tinImagePath;
        this.miscellaneousImagePath = res.miscellaneousImagePath;

        this.cnImagePath = res.cnImagePath;
        this.msmeImagePath = res.msmeImagePath;
        if (res.companyRegisterType == 1)
          this.msme = true;
        else
          this.msme = false;
        this.msmeFileName = res.cnImagePath;
        this.loadBalanceList = res.balanceSheetViewModel;
        if (this.loadBalanceList != null && this.loadBalanceList.length > 0) {
          this.loadbalance = true;
          if (this.loadBalanceList.length == 1) {
            this.balancesheetform.controls["balanceSheet_file"].setValue(this.loadBalanceList[0].imagePath);
            this.balancesheetform.controls["turnover"].setValue(this.loadBalanceList[0].turnOver);
            this.balanceSheetFileName = this.loadBalanceList[0].imagePath;
          } else if (this.loadBalanceList.length == 2) {
            this.balancesheetform.controls["balanceSheet_file"].setValue(this.loadBalanceList[0].imagePath);
            this.balancesheetform.controls["turnover"].setValue(this.loadBalanceList[0].turnOver);
            this.balancesheetform.controls["balanceSheet_file1"].setValue(this.loadBalanceList[1].imagePath);
            this.balancesheetform.controls["turnover1"].setValue(this.loadBalanceList[1].turnOver);
            this.balanceSheetFileName = this.loadBalanceList[0].imagePath;
            this.balanceSheetFileName1 = this.loadBalanceList[1].imagePath;
          } else {
            this.balancesheetform.controls["balanceSheet_file"].setValue(this.loadBalanceList[0].imagePath);
            this.balancesheetform.controls["turnover"].setValue(this.loadBalanceList[0].turnOver);
            this.balanceSheetFileName = this.loadBalanceList[0].imagePath;
            this.balancesheetform.controls["balanceSheet_file1"].setValue(this.loadBalanceList[1].imagePath);
            this.balancesheetform.controls["turnover1"].setValue(this.loadBalanceList[1].turnOver);
            this.balanceSheetFileName1 = this.loadBalanceList[1].imagePath;
            this.balancesheetform.controls["balanceSheet_file2"].setValue(this.loadBalanceList[2].imagePath);
            this.balancesheetform.controls["turnover2"].setValue(this.loadBalanceList[2].turnOver);
            this.balanceSheetFileName2 = this.loadBalanceList[2].imagePath;
          }

        }
        this.form.patchValue(res);
        if (this.manufacturerDetail.approvedStatusType == 1) {
          this.form.controls["gstStatus"].setValue("Active")
        }

        if (res.registrationType == 1) {
          this.manufacturer = true;
          this.manufactureranddealer = false;
        } else {
          this.manufacturer = false;
          this.manufactureranddealer = true;
        }
        if (res.gstStatusType == 2) {
          this.gstStatus = true;
        }
        this.form.controls['validityStartTs'].disable();
        this.form.controls['validityEndTs'].disable();
        let state = this.stateListCopy.filter(i => i.key == res.stateId);
        if (state != null && state.length > 0) {
          this.form.controls['stateId'].setValue(state[0].key);
          this.cashBookingService.districtByState(state[0].key, true).subscribe(result => {
            if (result) {
              this.districtList = result;
              this.districtListCopy = result;
              let district = result.filter(i => i.key == res.districtId);
              if (district.length > 0)
                this.form.controls['districtId'].setValue(district[0].key);
              if (district != null && district.length > 0) {
                this.cashBookingService.talukData(district[0].key, 1, true).subscribe(result => {
                  if (result) {
                    this.subDistrictList = result;
                    this.subDistrictListCopy = result;
                    let taluk = result.filter(i => i.key == res.talukId);
                    if (taluk.length > 0)
                      this.form.controls['talukId'].setValue(taluk[0].key);
                    if (taluk != null && taluk.length > 0) {
                      this.cashBookingService.getvillageLookUp(taluk[0].key, 1, true).subscribe(result => {
                        if (result) {
                          this.villageList = result;
                          this.villageListCopy = result;
                          let village = result.filter(i => i.key == res.villageId);
                          if (village.length > 0)
                            this.form.controls['villageId'].setValue(village[0].key);
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }

    });
    this.loading = false;

  }

  download(item: any) {
    // const linkSource = environment.imageBaseUrl + 'DBT/BalanceSheet/' + item;
    // const downloadLink = document.createElement('a');
    // const fileName = 'Leaflet.pdf';
    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();
    let src = environment.imageBaseUrl + 'DBT/BalanceSheet/' + item;
    window.open(encodeURI(src), '_blank');
  }

  gstdownload() {
    // const linkSource = environment.imageBaseUrl + 'DBT/GST/' + this.gstImagePath;
    // const downloadLink = document.createElement('a');
    // const fileName = 'TestReportCertificate.pdf';
    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();

    let src = environment.imageBaseUrl + 'DBT/GST/' + this.gstImagePath;
    window.open(encodeURI(src), '_blank');
  }
  incorporationdownload() {
    let src = environment.imageBaseUrl + 'DBT/Incorporation/' + this.incorporationImagePath;
    window.open(encodeURI(src), '_blank');
  }
  tINdownload() {
    let src = environment.imageBaseUrl + 'DBT/TIN/' + this.tINImagePath;
    window.open(encodeURI(src), '_blank');
  }
  miscellaneousdownload() {
    let src = environment.imageBaseUrl + 'DBT/Miscellaneous/' + this.miscellaneousImagePath;
    window.open(encodeURI(src), '_blank');
  }

  cndownload() {
    let src = environment.imageBaseUrl + 'DBT/MSME/' + this.cnImagePath;
    window.open(encodeURI(src), '_blank');
  }


  pandownload() {
    let src = environment.imageBaseUrl + 'DBT/PAN/' + this.panImagePath;
    window.open(encodeURI(src), '_blank');
  }

  msmedownload() {
    let src = environment.imageBaseUrl + 'DBT/MSME/' + this.msmeImagePath;
    window.open(encodeURI(src), '_blank');
  }

  statecommapnyChange() {
    this.getDistricts();
  }

  getDistricts() {
    this.districtList = [];
    this.cashBookingService.districtBySubDivision(1, true).subscribe(result => {
      if (result) {
        this.districtListCopy = result;
      }
    });
  }

  // openFileDialog(item: any) {
  //   let src = environment.imageBaseUrl + 'DBT/BalanceSheet/' + item;
  //   window.open(encodeURI(src ), '_blank')
  // }

  districtChange(event) {
    this.subDistrictList = [];
    this.cashBookingService.talukData(event.value, 1, true).subscribe(result => {
      if (result) {
        this.subDistrictListCopy = result;
      }
    });
  }

  talukChange(event) {
    this.villageList = [];
    this.cashBookingService.getvillageLookUp(event.value, 1, true).subscribe(result => {
      if (result) {
        this.villageListCopy = result;
      }
    });
  }

  stateChange() {
    if (this.form.value.stateId == "Tamil Nadu") {
      this.showtextdistrict = false;
      this.getDistricts();
    } else {
      this.showtextdistrict = true;
    }
  }

  getcompanyRegisteredList(refresh: boolean) {

    this.companyList = [];
    this.companyListCopy = [];
    this.manufacturerService.getCompanyRegisterList(refresh).subscribe(result => {
      if (result) {
        this.companyListCopy = result;
        this.companyList = result;
      }
    });
  }

  goToAction(item: number) {
    var data = {
      id: JSON.parse(this.id),
      approvedStatusType: item,
      remarks: "",
    }
    this.manufacturerService.manufacturerApprove(data).subscribe(res => {
      if (res && res.isSuccess) {
        this.alertService.success('Approved Successfully');
        this._location.back();
      } else {
        this.alertService.error(res.htmlFormattedFailures);
      }
    });
  }

  cancel() {
    const title = 'Confirmation';
    const Yes = 'Yes';
    const No = 'No';
    swal.fire(
      {
        title,
        text: 'Are you sure you want to cancel the registration ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: Yes,
        cancelButtonText: No,
      }
    )
      .then(res => {
        if (res.value) {
          this.router.navigate(['auth/login']);
        }
      });
  }

  showUpdatePopup() {
    const dialogRef = this.addServiceDialog.open(ManufacturerUpdatePopupComponent, {
      autoFocus: false,
      disableClose: true,
      width: '45%',
      height: '55%',
      panelClass: 'mat-dialog-serviceschedule',
      data: {
        id: this.manufacturerDetail.id,
        mobileNo: this.form.value.mobileNo,
        email: this.form.value.email,
        customerCareNo: this.form.value.customerCareNo,
        customerCareNo1: this.form.value.customerCareNo1,
        customerCareNo2: this.form.value.customerCareNo2,
        corporateContactPersonName: this.form.value.corporateContactPersonName,
        corporateContactPersonEmail: this.form.value.corporateContactPersonEmail,
        corporateContactPersonDesignation: this.form.value.corporateContactPersonDesignation,
        corporateContactPersonMobileNo: this.form.value.corporateContactPersonMobileNo,
        authorizedPersonName: this.form.value.authorizedPersonName,
        authorizedPersonEmail: this.form.value.authorizedPersonEmail,
        authorizedPersonDesignation: this.form.value.authorizedPersonDesignation,
        authorizedPersonMobileNo: this.form.value.authorizedPersonMobileNo,
        certificateNumber: this.form.value.certificateNumber,
        manufacturerType: JSON.stringify(this.manufacturerTypeIdList),
        validityEndTs: (this.form.value.validityEndTs == "" || this.form.value.validityEndTs == null) ? null : moment(this.form.value.validityEndTs).format('YYYY-MM-DD'),
        validityStartTs: (this.form.value.validityStartTs == "" || this.form.value.validityStartTs == null) ? null : moment(this.form.value.validityStartTs).format('YYYY-MM-DD'),
        attachment: this.attachmentData,
        dbtManufacturerBalanceSheetMappingViewModel: this.balanceSheetData,
        approvedStatusType: 0
      }
    });
    dialogRef.afterClosed().subscribe(data => {
      this.onCancel();
      this.isCorporateContact = true;
      this.isAuthorizedContact = true;
      this.isBalanceSheet = true;
      this.ismsme = true;
    });
  }

  submit() {
    this.form.controls['validityEndTs'].clearValidators();
    this.form.controls['validityEndTs'].updateValueAndValidity();
    this.manufacturerTypeIdList = [];
    const selectedManufacturerType = this.form1.get('manufacturerType').value;
    if (selectedManufacturerType && selectedManufacturerType.length > 0) {
      selectedManufacturerType.forEach(element => {
        this.manufacturerTypeIdList.push(element.key);
      });
    }

    this.balanceSheetData = [];
    if (this.loadBalanceList.length == 1 && this.balancesheetform.value.turnover > 0) {
      this.balanceSheetData.push({
        'id': this.loadBalanceList[0].id,
        'year': this.loadBalanceList[0].year,
        'turnOver': JSON.parse(this.balancesheetform.value.turnover),
        'attachment': this.attachmentbalanceSheetData
      });
    }
    else if (this.loadBalanceList.length == 2) {
      if (this.balancesheetform.value.turnover > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[0].id,
          'year': this.loadBalanceList[0].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover),
          'attachment': this.attachmentbalanceSheetData
        });
      }
      if (this.balancesheetform.value.turnover1 > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[1].id,
          'year': this.loadBalanceList[1].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover1),
          'attachment': this.attachmentbalanceSheetData1
        });
      }
    }
    else {
      if (this.balancesheetform.value.turnover > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[0].id,
          'year': this.loadBalanceList[0].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover),
          'attachment': this.attachmentbalanceSheetData
        });
      }
      if (this.balancesheetform.value.turnover1 > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[1].id,
          'year': this.loadBalanceList[1].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover1),
          'attachment': this.attachmentbalanceSheetData1
        });
      }
      if (this.balancesheetform.value.turnover2 > 0) {
        this.balanceSheetData.push({
          'id': this.loadBalanceList[2].id,
          'year': this.loadBalanceList[2].year,
          'turnOver': JSON.parse(this.balancesheetform.value.turnover2),
          'attachment': this.attachmentbalanceSheetData2
        });
      }
    }

    if (this.form.valid) {
      if (this.isSeekClarification) {
        this.showUpdatePopup();
      } else {
        let data = {
          id: this.manufacturerDetail.id,
          mobileNo: this.form.value.mobileNo,
          email: this.form.value.email,
          customerCareNo: this.form.value.customerCareNo,
          customerCareNo1: this.form.value.customerCareNo1,
          customerCareNo2: this.form.value.customerCareNo2,
          organisationTName: this.form.value.organisationTName,
          corporateContactPersonName: this.form.value.corporateContactPersonName,
          corporateContactPersonEmail: this.form.value.corporateContactPersonEmail,
          corporateContactPersonDesignation: this.form.value.corporateContactPersonDesignation,
          corporateContactPersonMobileNo: this.form.value.corporateContactPersonMobileNo,
          authorizedPersonName: this.form.value.authorizedPersonName,
          authorizedPersonEmail: this.form.value.authorizedPersonEmail,
          authorizedPersonDesignation: this.form.value.authorizedPersonDesignation,
          authorizedPersonMobileNo: this.form.value.authorizedPersonMobileNo,
          certificateNumber: this.form.value.certificateNumber,
          manufacturerType: JSON.stringify(this.manufacturerTypeIdList),
          validityEndTs: (this.form.value.validityEndTs == "" || this.form.value.validityEndTs == null) ? null : moment(this.form.value.validityEndTs).format('YYYY-MM-DD'),
          validityStartTs: (this.form.value.validityStartTs == "" || this.form.value.validityStartTs == null) ? null : moment(this.form.value.validityStartTs).format('YYYY-MM-DD'),
          attachment: this.attachmentData,
          dbtManufacturerBalanceSheetMappingViewModel: this.balanceSheetData,
        }

        this.manufacturerService.update(data).subscribe(res => {
          if (res && res.isSuccess) {
            this.alertService.success('Manufacturer Updated Successfully');
            this.onCancel();
          }
          else {
            this.alertService.error(res.htmlFormattedFailures);
          }
        });
      }
    } else {
      this.genericValidator.validateFormControl(this.form);
    }
  }

  openPopup() {
    const dialogRef = this.addServiceDialog.open(ManufacturerpopupComponent, {

      autoFocus: false,
      disableClose: true,
      width: '38%',
      height: '45%',
      panelClass: 'mat-dialog-serviceschedule',
      data: {
        id: this.manufacturerDetail.id,
      }
    });
  }
  oncancel() {
    this._location.back();
  }

  showPopup() {
    const dialogRef = this.addServiceDialog.open(ManufacturerclarifypopupComponent, {

      autoFocus: false,
      disableClose: true,
      width: '45%',
      height: '55%',
      panelClass: 'mat-dialog-serviceschedule',
      data: {
        id: this.id,
      }
    });
  }
  back() {
    this._location.back();
  }

  checkUser(pageType) {
    // this.generate2OTP();
    this.SendOTPMobile();
  }
}

